import './services/mobile-device';
import './services/insurance-service';
import './services/questions-service';
import './services/user-service';

import './views/main-view';
import './views/login-view';
import './views/lh-app/lh-app';

import './views/components/lh-header';
import './views/components/circle-spinner';
import './views/components/ahoy-loader';
import './views/components/lh-rotate-your-phone';
import './views/components/lh-ocr-select';
import './views/components/lh-app-header';
import './views/components/lh-header-line';
import './views/components/arc-progress';
import './views/components/lh-question-group';
import './views/components/lh-questionnaire';
import './views/components/lh-image-upload-button';
import './views/components/lh-image-upload-button-error';
import './views/components/lh-allready-registered';
import './views/components/lh-accept-terms';
import './views/components/lh-accept-payment-terms';
import './views/components/lh-accept-terms-manual-data-attestation';

import './services/trailer-api-service';
import './services/motor-type-data-service';
import './services/coverages-data-service';
import './services/deductibles-data-service';
import './views/popups/popup-manager';
import { debounce } from '@ahoy/ui/debounce';

import './views/popups/section-complete-popup';
import './views/popups/section-layout-popup';
import './views/popups/summary-notice-popup';
import './views/popups/claims-popup';
import './views/popups/experiance-popup';
import './views/popups/purchase-year-popup';
import './views/popups/welcome-new-user-popup';
import './views/popups/welcome-login-no-user-popup';
import './views/popups/welcome-existing-user-popup';
import './views/popups/welcome-promotion-popup';
import './views/popups/non-eligible-popup';
import './views/popups/non-eligible-popup-add-boat';
import './views/popups/before-exit-popup';
import './views/popups/non-eligible-popup-instanda';
import './views/popups/non-eligible-popup-type-2';
import './views/popups/survey-complete-popup';
import './views/popups/package-selection-popup';
import './views/popups/package-selection-email-success-popup';
import './views/popups/boat-details-value-warning-popup';
import './views/popups/boat-details-value-not-found-warning-popup';
import './views/popups/boat-details-value-not-found-agent-warning-popup';
import './views/popups/boat-details-min-value-warning-popup';
import './views/popups/boat-details-buy-now-error-popup';
import './views/popups/boat-details-min-buy-now-error-popup';
import './views/popups/package-selection-email-fail-popup';
import './views/popups/payment-terms-and-conditions-popup';
import './views/popups/pricing-packages-faq-popup';
import './views/popups/complete-questionaire-popup';
import './views/popups/about-popup';/** @deprecated */
import './views/popups/congrats-popup';
import './views/popups/mta-complete-popup';
import './views/popups/renewal-complete-popup';
import { defer } from './utils/async-store';
import { resolve } from './mixins/dependency';
import { ConfigService } from './services/config-service';
import { AhoyFlavor } from '@FLAVOR/../../common/types';

function initSenrty() {
  // @ts-ignore
  if (window.Sentry) {
    // @ts-ignore
    Sentry.init({
      dsn:
        'https://989fee38b9b147a7ba4b40196bd957a0@o1029014.ingest.sentry.io/5996042',
      // @ts-ignore
      integrations: [new Sentry.Integrations.BrowserTracing()],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
    console.info('Sentry initialized');
  } else {
    console.info('Sentry not yet loaded');
    if (process.env.NODE_ENV !== 'development') setTimeout(() => initSenrty(), 450);
  }
}

initSenrty();

initMobileDevice();
async function initMobileDevice() {
  const { MobileDeviceService }: any = await import(/* webpackChunkName: 'mobile-service' */ './services/mobile-device');

  try {
    const isMobile = (<any>navigator).userAgentData?.mobile ||
      navigator.userAgent.toLowerCase().indexOf('mobile') >= 0;
    if (isMobile) {
      const height = window.getComputedStyle(document.body).height;
      document.body.style.setProperty('--maxH', height);
      MobileDeviceService.mobileDetected = true;
      MobileDeviceService.mobileHeight = document.body.getBoundingClientRect().height;
    } else {
      function update() {
        document.body.style.setProperty(
          '--maxH',
          document.body.getBoundingClientRect().height + 'px',
        );
      }
      const doUpdate = debounce(update, 300);
      window.addEventListener('resize', () => doUpdate());
      document.body.setAttribute('desktop', '');
      document.firstElementChild!.setAttribute('desktop', '');
      doUpdate();
    }
    const appFlavor = resolve(ConfigService.serviceName).get('flavor') as AhoyFlavor;
    const useMobileStyle = (isMobile);
    document.firstElementChild!.setAttribute('flavor', appFlavor);
    document.firstElementChild!.setAttribute('device', useMobileStyle ? 'mobile' : 'desktop');
    document.body.setAttribute('device', useMobileStyle ? 'mobile' : 'desktop');
    defer('device-detect').resolve(void 0);
    // const isMobile = false;
  } catch  {
    console.log('Mobile detection failed');
  } finally {
    MobileDeviceService.define();
    const placeholder = document.body.querySelector('pending-main-view');
    if (placeholder) {
      placeholder.outerHTML = '<main-view style="opacity:1"></main-view>';
    }
  }
}

